var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.403,26.617H50v-1.182c0-1.104-0.896-2-2-2s-2,0.896-2,2v1.182H24.597c-1.104,0-2,0.896-2,2v5.29c0,1.104,0.896,2,2,2 h0.279v22.436c0,1.104,0.896,2,2,2H46v2.96l-9.555,5.534c-0.956,0.554-1.282,1.777-0.728,2.732 c0.371,0.641,1.042,0.998,1.732,0.998c0.34,0,0.685-0.087,1-0.27L46,67.923v2.642c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.642 l7.551,4.373c0.315,0.183,0.66,0.27,1,0.27c0.69,0,1.362-0.357,1.732-0.998c0.554-0.955,0.228-2.179-0.729-2.732L50,63.302v-2.96 h19.124c1.104,0,2-0.896,2-2V35.906h0.279c1.104,0,2-0.896,2-2v-5.29C73.403,27.512,72.508,26.617,71.403,26.617z M26.597,30.617 h42.807v1.29h-0.279H26.876h-0.279V30.617z M67.124,56.342H28.876V35.906h38.248V56.342z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.162fbc1df7b9d34df6faf671f34af1f8.svg";
export { ForwardRef as ReactComponent };